
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _errorPtmDDRvvL_45bRdY3RIywopwjNFxMVjFQSzbEGI24XhdoMeta } from "/opt/node_app/app/src/pages/_error.vue?macro=true";
import { default as _reportsiWFhOe7e4e3Y8_7H0U51GCj4Iq64zqn61WaaV2GPMwwMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/_reports.vue?macro=true";
import { default as _91_46_46_46slug_93ePRUG8_45OzKDVbiI3Aal57V2G8BoFQX8gy1wwOOfcC7YMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/[...slug].vue?macro=true";
import { default as _kitchen_45sinkwIkhVN_45SV3EVTm3Tp7FL3oQzfuCkE9VmbyNHsXVidDoMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/_kitchen-sink.vue?macro=true";
import { default as readyBBFPMvu9arZQvUcm1pZRvu_45d9OfNse_S_45O_45_457bkCjLoMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/_probes/nuxt/ready.vue?macro=true";
export default [
  {
    name: "_error",
    path: "/_error",
    component: () => import("/opt/node_app/app/src/pages/_error.vue")
  },
  {
    name: "_reports",
    path: "/_reports",
    meta: _reportsiWFhOe7e4e3Y8_7H0U51GCj4Iq64zqn61WaaV2GPMwwMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/_reports.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93ePRUG8_45OzKDVbiI3Aal57V2G8BoFQX8gy1wwOOfcC7YMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/[...slug].vue")
  },
  {
    name: "_kitchen-sink",
    path: "/_kitchen-sink",
    meta: _kitchen_45sinkwIkhVN_45SV3EVTm3Tp7FL3oQzfuCkE9VmbyNHsXVidDoMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/_kitchen-sink.vue")
  },
  {
    name: "_probes-nuxt-ready",
    path: "/_probes/nuxt/ready",
    meta: readyBBFPMvu9arZQvUcm1pZRvu_45d9OfNse_S_45O_45_457bkCjLoMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1087_db0@0.3.1_encoding@0.1.13_ioredis@5.6.0_magicast@0.3.5_typescript@5.8.2_yelrlfcktgybgplbhjto4c2fhq/node_modules/@edco/apollo/src/pages/_probes/nuxt/ready.vue")
  }
]